import {
  META_DATA,
  PARTNER_DATA,
  HERO_DATA,
  INFO_DATA,
  INTROS_DATA,
  PREVIEW_DATA,
  COACH_DATA,
  AFTER_BOOTCAMP_DATA,
  BENEFITS_DATA,
  PRICE_DATA,
  BOOTCAMP_TEMPLATES,
} from "./bootcamp-enroll.constants"

// customized SEO Meta, not necessary for every bootcamp
export const bootcampMetaByKey = key => {
  key = (key || "").toLowerCase()
  return META_DATA[key] || {}
}

export const bootcampPartnerByKey = key => {
  key = (key || "").toLowerCase()
  return PARTNER_DATA[key] || {}
}

export const bootcampHeroByKey = key => {
  key = (key || "").toLowerCase()
  return HERO_DATA[key] || {}
}

// this is getting data for bootcampMeta.vue section data
export const bootcampInfoByKey = key => {
  key = (key || "").toLowerCase()
  return INFO_DATA[key] || []
}

export const bootcampIntrosByKey = key => {
  key = (key || "").toLowerCase()
  return INTROS_DATA[key] || []
}

export const bootcampPreviewByKey = key => {
  key = (key || "").toLowerCase()
  return PREVIEW_DATA[key] || {}
}

export const bootcampCoachByKey = key => {
  key = (key || "").toLowerCase()
  return COACH_DATA[key] || {}
}

export const afterBootcampByKey = key => {
  key = (key || "").toLowerCase()
  return AFTER_BOOTCAMP_DATA[key] || {}
}

export const bootcampBenefitsByKey = key => {
  key = (key || "").toLowerCase()
  return BENEFITS_DATA[key] || {}
}

export const bootcampPriceByKey = key => {
  key = (key || "").toLowerCase()
  return PRICE_DATA[key] || 179
}

// Returns the set of components that should be rendered
export const bootcampTemplateByKey = key => {
  key = (key || "").toLowerCase()
  return BOOTCAMP_TEMPLATES[key] || []
}



// WEBPACK FOOTER //
// ./src/store/bootcamp-enroll/bootcamp-enroll.utils.js